import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { Home } from 'lucide-react';

import { ROUTE_URLS } from '../../../routes';
import { useI18n } from '../../../i18n';

export const NotFound = () => {
  const { t } = useI18n();
  return (
    <div className='wm-center-page'>
      <div>
        <div className='wm-404'>404</div>
        <h2 style={{ marginTop: 16 }}>{t('notFound.title')}</h2>
        <p className='wm-muted' style={{ margin: '6px 0 20px' }}>
          {t('notFound.text')}
        </p>
        <Link to={ROUTE_URLS.HOME}>
          <Button type='primary' icon={<Home size={16} />}>
            {t('notFound.home')}
          </Button>
        </Link>
      </div>
    </div>
  );
};
